/* eslint-disable react/jsx-no-useless-fragment */
// import { memo } from 'react';
import { List } from '@mui/material';

// TODO -> Add an user level property here or a property driven string for auth nav item

import MenuItem from './MenuItem';
import menuItems from './menu-definition';
import { AppContext, AppContextType } from 'context/AppContext';
import React from 'react';

type MenuListProps = {
    drawerOpen: boolean;
};

const MenuList = ({ drawerOpen }: MenuListProps) => {
    const {
        setAppToken,
        propertyManager: { isPropertyEnabled, loaded }
    } = React.useContext(AppContext) as AppContextType;
    // TODO If groups are desired we must refactor this in order to use a proper handler for it
    const navItems = menuItems
        .filter((item) => isPropertyEnabled(item.authorization, false))
        .map((item) => <MenuItem key={item.id} item={item} level={1} drawerOpen={drawerOpen} />);

    React.useEffect(() => {
        if (navItems.length === 0 && loaded) {
            setAppToken(undefined);
        }
    }, [loaded, navItems, setAppToken]);

    return <List>{navItems}</List>;
};

export default MenuList;
